import { apiFetch } from '../apiFetch'

export const getPermissions = async () => {
  return await apiFetch({
    path: '/admin/permissions'
  })
}
